import { VideoLightbox } from '@kkf/design'
import { SERVICE_DETAIL } from '../data/service-details'
import { useT } from '../i18n'

/** The service-details page. */
export function ServiceDetailsPage() {
  const t = useT()
  const d = SERVICE_DETAIL

  return (
    <>
      {/* No banner and no breadcrumb (2026-09-21) — see `ContactPage` for the two things
          that travel with dropping one: the page's `<h1>`, which `Breadcrumb` used to
          carry, and `header.plainRoutes`, which nothing fails without. */}
      <section className="ul-service-details ul-section-spacing ul-plain-page-top">
        <div className="ul-container">
          <div>
            <div className="ul-service-details-img">
              <img src={d.image} alt={t('alt.generic')} />
            </div>

            <div className="ul-service-details-txt">
              {/* The page's one `<h1>`, and it always said the right thing — it was an
                  `<h2>` only because `Breadcrumb` was printing "Service Details" above it. */}
              <h1 className="ul-service-details-title">{d.title}</h1>
              {d.intro.map((p, i) => (
                <p className="ul-service-details-descr" key={i}>
                  {p}
                </p>
              ))}
              <div className="ul-service-details-inner-block">
                <h3 className="ul-service-details-inner-title">{d.firstBlock.title}</h3>
                <p className="ul-service-details-descr">{d.firstBlock.body}</p>
              </div>
            </div>

            <div className="ul-service-details-video-cover">
              <img src={d.videoCover} alt={t('alt.videoCover')} />
              <VideoLightbox source={d.videoUrl}>{t('video.play')}</VideoLightbox>
            </div>

            <div className="ul-service-details-txt">
              <p className="ul-service-details-descr">{d.afterVideo}</p>
              <div className="ul-service-details-inner-block">
                <h3 className="ul-service-details-inner-title">{d.secondBlock.title}</h3>
                <p className="ul-service-details-descr">{d.secondBlock.body}</p>
                <ul>
                  {d.secondBlock.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
